import type {ZodError} from 'zod';

export const flattenFieldErrors = (
  error: ZodError | null | undefined
): Record<string, string | undefined> => {
  if (!error) return {};
  return Object.fromEntries(
    Object.entries(error.flatten().fieldErrors).map(([k, v]) => [
      k,
      (v as string[] | undefined)?.[0]
    ])
  );
};

/** Keyed by the full dot-joined issue path — supports nested fields like `pep.parties.0.fullName`. */
export const flattenFieldErrorsByPath = (
  error: ZodError | null | undefined
): Record<string, string | undefined> => {
  if (!error) return {};
  const result: Record<string, string | undefined> = {};
  for (const issue of error.issues) {
    const key = issue.path.join('.');
    if (!result[key]) result[key] = issue.message;
  }
  return result;
};

/** Shared by every activation step form: a live-computed field error only surfaces once
 * `showErrors` allows it, translating the stored i18n key on the way out. */
export const resolveFieldError = (
  showErrors: boolean,
  fieldErrors: Record<string, string | undefined>,
  t: (key: string) => string,
  key: string
): string | undefined =>
  showErrors && fieldErrors[key] ? t(fieldErrors[key] as string) : undefined;
